<ng-container>
  <img src="../../../assets/images/renterz-logo.svg" alt="Renterz Logo" class="company-icon">
  <form class="custom-form" #form="ngForm" (ngSubmit)="getVerificationCode(form)">
    <p class="login-card-title">{{ translationService.instant('auth.welcomeTitle', 'Welcome Back!') }}</p>
    <p class="login-card-subtitle">{{ translationService.instant('auth.welcomeSubtitle', 'Welcome back! Please enter
      your details.') }}</p>

    <br />
    <div class="form-group">
      <div class="label-mobile mb-1">{{ translationService.instant('auth.mobileNumber', 'Mobile Number') }}</div>
      <div class="container-user-input-mobile">
        <div class="country-picker-wrapper">
          <app-country-picker [displayFormat]="'code'" [showFlag]="true" (countrySelected)="onCountrySelected($event)"
            placeholder="{{ translationService.instant('auth.selectCountry', 'Select Country') }}"></app-country-picker>
        </div>
        <div class="container-input">
          <input minlength="9" autofocus required type="tel"
            placeholder="{{ translationService.instant('auth.enterMobilePlaceholder', 'Enter your mobile number') }}"
            class="input-mobile" [pattern]="mobilePattern" name="phone" #phoneInput="ngModel" [(ngModel)]="phone" />
        </div>
      </div>
      @if (phoneInput.invalid && (phoneInput.dirty || phoneInput.touched)) {
      <div class="row ml-4">
        <span class="form-field-error-container">
          @if (phoneInput.errors?.['required']) {
          <span class="form-field-error">{{ translationService.instant('auth.mobileRequired', 'Mobile number is
            required.') }}</span>
          }
          @if (phoneInput.errors?.['minlength'] || phoneInput.errors?.['pattern'] ) {
          <span class="form-field-error">{{ translationService.instant('auth.mobileInvalid', 'Enter a Mobile number with
            at least 9 digits.') }}</span>
          }
        </span>
      </div>
      }
    </div>
    <button type="submit" class="button-get-otp">{{ translationService.instant('auth.getVerificationCode', 'Get
      Verification Code') }}</button>

    <!-- <div class="positon-relative">

        <span class="hr-or">OR</span>
        <hr class="hr">
      </div> -->
    <!-- <button type="button" class="button-social-login"><img src="../../../assets/images/google-logo.svg" alt="apple logo"
      height="20px" width="20px" class="social-login-logo"><span class="content">Sign up with Google</span></button>
      <button type="button" class="button-social-login"><img src="../../../assets/images/apple-logo.svg" alt="apple logo" class="social-login-logo"
        height="24px" width="20px"><span class="content">Sign up with Apple</span></button> -->
  </form>
</ng-container>